import { GamePlace } from 'constants/cards';
import { GameName } from 'constants/difficulty';
import { KingImages } from 'constants/tutorialKingImages';
import { SolitaireGame } from 'game/SolitaireGame';

const moves = [
    { cards: ['A3'], target: 'F' }, //
    { cards: ['23'], target: 'A3' }, //
    { cards: ['33'], target: '23' }, //
    { cards: ['51'], target: '62' }, //
    { cards: ['70'], target: '83' }, //
    { cards: ['92', '81'], target: 'T1' }, //
    { cards: ['J1'], target: 'C' }, //
    { cards: ['K3'], target: 'FR' }, //

    {
        cards: [],
        target: '',
        freePlay: true,
        limit: [GamePlace.TABLEAU],
        freePlayCondition: (game: SolitaireGame) => {
            const hiddenColumns = game.columns.filter((c) => c.hasHiddenCards).length;
            return !hiddenColumns && game.foundations.filter((f) => f.isComplete).length === 7;
        },
    },

    {
        cards: [],
        target: '',
        freePlay: true,
        freePlayCondition: () => {
            return false;
        },
    },
    //
];
const contentKeys = [
    { king: KingImages.RIGHT_BLACK_THREE, contentKey: 'freeCellTutorialStep1' }, //
    { king: KingImages.RIGHT_BLACK_THREE, contentKey: 'freeCellTutorialStep1' }, //
    { king: KingImages.RIGHT_BLACK_THREE, contentKey: 'freeCellTutorialStep1' }, //
    { king: KingImages.HANDS_DOWN, contentKey: 'freeCellTutorialStep2' },
    { king: KingImages.HANDS_DOWN, contentKey: 'freeCellTutorialStep2' },
    { king: KingImages.LEFT_RED_BLACK_RIGHT_RED, contentKey: 'freeCellTutorialStep3' },
    { king: KingImages.HANDS_FORWARD, contentKey: 'freeCellTutorialStep4' },
    { king: KingImages.LEFT_DARK_GREEN, contentKey: 'freeCellTutorialStep5' },
    { king: KingImages.HANDS_UP, contentKey: 'freeCellTutorialStep6' },
];
const step = {
    gameId: 'freeCell_tutorial_step_1',
    columns: [
        [
            { code: 'K0', visible: true },
            { code: 'J3', visible: true },
            { code: 'J0', visible: true },
            { code: '93', visible: true },
            { code: '72', visible: true },
            { code: '50', visible: true },
            { code: '42', visible: true },
        ],
        [
            { code: 'Q2', visible: true },
            { code: 'T2', visible: true },
            { code: '90', visible: true },
            { code: '61', visible: true },
            { code: '53', visible: true },
            { code: '40', visible: true },
            { code: '31', visible: true },
        ],
        [
            { code: 'T0', visible: true },
            { code: '73', visible: true },
            { code: '63', visible: true },
            { code: '41', visible: true },
            { code: '30', visible: true },
            { code: '32', visible: true },
            { code: '21', visible: true },
        ],
        [
            { code: '22', visible: true },
            { code: 'A2', visible: true },
            { code: '20', visible: true },
            { code: 'A0', visible: true },
            { code: 'A1', visible: true },
            { code: 'K3', visible: true },
            { code: 'J1', visible: true },
        ],
        [
            { code: '92', visible: true },
            { code: '81', visible: true },
            { code: '70', visible: true },
            { code: '51', visible: true },
            { code: '33', visible: true },
            { code: 'A3', visible: true },
        ],
        [
            { code: 'K1', visible: true },
            { code: 'Q3', visible: true },
            { code: 'Q0', visible: true },
            { code: '91', visible: true },
            { code: '83', visible: true },
            { code: '23', visible: true },
        ],
        [
            { code: 'Q1', visible: true },
            { code: 'T3', visible: true },
            { code: '80', visible: true },
            { code: '52', visible: true },
            { code: '43', visible: true },
            { code: '62', visible: true },
        ],
        [
            { code: 'J2', visible: true },
            { code: 'K2', visible: true },
            { code: '82', visible: true },
            { code: '71', visible: true },
            { code: '60', visible: true },
            { code: 'T1', visible: true },
        ],
    ],
    foundation: [[], [], [], []],
    name: GameName.FREECELL,
    movesCount: 0,
    moves: [],
    attempts: 0,
    score: 0,
    time: 0,
    wastePile: [],
    freeCells: [[], [], [], []],
    stockpile: [],
};

export default { step, moves, contentKeys };
